import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { FaNetworkWired } from "react-icons/fa";
import { HiOutlineCpuChip } from "react-icons/hi2";
import { BiNetworkChart } from "react-icons/bi";

import RouterLogs from './RouterLogs';
import SwitchLogs from './SwitchLog';
import OltLog from './OltLog';

import './LogManage.css';

const LogManage = () => {
    const { t } = useTranslation();
    const [selectedLogType, setSelectedLogType] = useState(null);

    const handleBack = () => setSelectedLogType(null);

    const renderLogComponent = () => {
        switch (selectedLogType) {
            case "Router":
                return <RouterLogs onBack={handleBack} />;
            case "OLT":
                return <OltLog onBack={handleBack} />;
            case "Switch":
                return <SwitchLogs onBack={handleBack} />;
            default:
                return null;
        }
    };

    const devices = [
        {
            id: "Router",
            title: "Router Logs",
            icon: <FaNetworkWired className="device-icon-svg" />
        },
        {
            id: "OLT",
            title: "OLT Logs",
            icon: <HiOutlineCpuChip className="device-icon-svg" />
        },
        {
            id: "Switch",
            title: "Switch Logs",
            icon: <BiNetworkChart className="device-icon-svg" />
        }
    ];

    return (
        <div className={`log-page-container ${!selectedLogType ? 'is-centered' : 'is-active'}`}>
            
            {/* Device Selection Cards - ড্রপডাউনের পরিবর্তে আইকন কার্ড */}
            {!selectedLogType && (
                <div className="log-header-section">
                    <h2 className="log-title">
                        {t('log_monitoring')}
                    </h2>
                    
                    <div className="device-card-grid">
                        {devices.map((device) => (
                            <div 
                                key={device.id} 
                                className="device-status-card"
                                onClick={() => setSelectedLogType(device.id)}
                            >
                                <div className="device-icon-wrapper">
                                    {device.icon}
                                </div>
                                <h3 className="device-card-label">{device.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Log Viewer */}
            {selectedLogType && (
                <div className="log-viewer-body">
                    {renderLogComponent()}
                </div>
            )}
        </div>
    );
};

export default LogManage;
